import styled from 'styled-components';

import { media } from '../../../helpers/breakpoints';
import { InfoTitle, type InfoTitleProps } from '../InfoTitle/InfoTitle';
import { DetailList } from '../DetailList/DetailList';
import type { InfoListItemProps, Variant } from '../InfoListItem/InfoListItem';
import { Link } from '../Button/Link';

export interface DetailPanelProps extends InfoTitleProps {
  detailListItems?: InfoListItemProps[] | null;
  link?: {
    url?: string;
    text?: string;
    external?: boolean;
  };
  illustrationUrl: string;
  className?: string;
  detailListVariant?: Variant;
}

const SLink = styled(Link)`
  margin-left: ${({ theme }) => theme.spacing.L56};

  ${media.medium} {
    position: absolute;
    top: 0;
    right: 0;
    margin-left: 0;
  }
`;

const Container = styled.div`
  ${media.medium} {
    position: relative;
  }
`;

const SDetailList = styled(DetailList)`
  padding: ${({ theme }) =>
    `${theme.spacing.M16} ${theme.spacing.M16} 0 ${theme.spacing.M16}`};
`;

function DetailPanel({
  detailListItems,
  link,
  title,
  listItems,
  illustrationUrl,
  detailListVariant = 'DEFAULT',
  className,
}: DetailPanelProps) {
  return (
    <Container className={className}>
      <InfoTitle
        title={title}
        listItems={listItems}
        illustration={illustrationUrl}
      />
      {link && (
        <SLink
          ofType="SECONDARY"
          href={link?.url}
          target={link?.external ? '_blank' : '_self'}
          data-testid="detail-panel-link"
          rel={link?.external ? 'noopener' : undefined}
          underline
        >
          {link?.text}
        </SLink>
      )}
      {detailListItems && (
        <SDetailList
          list={detailListItems}
          infoTitleVariant={detailListVariant}
        />
      )}
    </Container>
  );
}

export { DetailPanel };
